import { Component } from '@angular/core';
import { LayoutComponent } from './layout/layout.component';

/**
 * Root application component using Angular 20 standalone pattern
 */
@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  standalone: true,
  styleUrl: './app.scss',
  imports: [LayoutComponent],
})
export class App {
  protected title = 'estokai-web';
}
